import $ from 'jquery';
import Muuri from 'muuri';



/**
 * Masonry
 */
$('.masonry').each(function () {

    const $element = $(this);

    new Muuri($element[0], {
        items: '.masonry-item',
        layout: {
            fillGaps: true,
        }
    });

});


